import { useQuery } from "@tanstack/react-query"
import deepEqual from "fast-deep-equal"

import usePrevious from "@p-ban/common/src/hooks/usePrevious"

import type { EstimateParams } from "../../features/oneClickEstimate/types/params"
import useEstimateCache from "./cache/estimateCache"
import csComEstApi from "./csComEstApi"

const useEstimateQuery = (params: EstimateParams, enabled = true) => {
  const prevParams = usePrevious(params)
  const estimateCache = useEstimateCache()
  if (enabled && !deepEqual(prevParams, params)) {
    estimateCache.removeExpiredCache(params)
  }

  const key = estimateCache.createCacheKey(params)
  const { data, isFetching, isError, error } = useQuery(key, () => csComEstApi.exec(params), {
    keepPreviousData: true,
    enabled,
  })

  if (isError || error !== null) {
    return {
      data: undefined,
      isLoading: isFetching,
      isError: true,
    }
  }

  return {
    data,
    isLoading: !data || isFetching,
    isError: false,
  }
}

export default useEstimateQuery
